﻿import Glider from 'glider-js';
import { Collapsible } from './collapsible';
import { DropdownOption } from './dropdownOption';

export const GliderDropdown = function (dropdown, config, onOptionSelected, onOpened){
    const self = this;

    const gliderName = dropdown.querySelector('.glider').getAttribute('data-glider');
    const gliderDots = () => `.${gliderName}-dots`.toString();

    const defaultConfig = {
        exactWidth: false,
        draggable: false,
        scrollLock: true,
        resizeLock: true,
        itemWidth: 200,
        duration: 0.25,
        slidesToScroll: 'auto',
    };

    const gliderConfig = () => {
        return {...defaultConfig, ...{ dots: gliderDots() }, ...{ responsive: config } };
    };
    
    const glider = dropdown.querySelector(`[data-glider='${gliderName}']`);

    if (glider !== null) {    
        const config =  gliderConfig();

        new Glider(glider, config); 
    }

    function onCollapsibleToggled(e) {
        if (e.isOpen) {
            dropdown.addEventListener("click", handleOptionClick);
            if (typeof onOpened == "function") {
                onOpened(self);
            }
        } else {
            dropdown.removeEventListener("click", handleOptionClick);
        }
    }

    const collapsible = Collapsible(dropdown, onCollapsibleToggled);

    const options = [...dropdown.querySelectorAll(DropdownOption.selectors.root)]
        .map(opt => DropdownOption(opt));
    
    function handleOptionClick(e) {
        const optionNode = e.target.closest(DropdownOption.selectors.root);

        if (optionNode) {
            selectOption(optionNode, e);
        }
    }
    
    function selectOption(option, event) {
        const optionToSelect = options.find(o => o.elem === option);

        if (optionToSelect.isDisabled()) {
            event.preventDefault();
            return;
        }

        const selectedOption = getSelectedOption();

        if (selectedOption) {
            selectedOption.deselect();
        }


        optionToSelect.select();

        if (typeof onOptionSelected === "function") {
            onOptionSelected(optionToSelect, event);
        }

        close();
    }

    function getSelectedOption() {
        const selectedOptions = options.filter(option => option.isSelected());

        return selectedOptions.length > 0 ? selectedOptions[0] : null;
    }

    function close() {
        collapsible.close();
    }

    return {
        close,
    };
};

GliderDropdown.selectors = {
    root: "[data-component='journey-dropdown']",
};